const allRegex = {
  emailReg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  idCardReg: /(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0[1-9]|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/,
  phoneReg: /^(?:(?:\+|00)86)?1[3-9]\d{9}$/,
  // jaPhoneReg: /^\d{2}(?:-\d{4}-\d{4}|\d{8}|\d-\d{3,4}-\d{4})$/,
  jaPhoneReg: /^[0-9]{10,11}$/,
  jaNameReg: /^[^\s]*$/,
  klarnaPhoneReg: /^[0-9]*$/
  
};
export default allRegex;

